// src/Utils/shareScope.js

// Normaliza el scope
export const getShareScope = (routeOrScope) => {
  const scope =
    typeof routeOrScope === "string"
      ? routeOrScope
      : routeOrScope?.share?.scope;

  return scope === "institution" || scope === "global" ? scope : "none";
};

// Texto a mostrar
export const getShareScopeLabel = (routeOrScope) => {
  const scope = getShareScope(routeOrScope);
  if (scope === "institution") return "Del centro";
  if (scope === "global") return "Comunidad";
  return "Privada";
};

// Props útiles para un badge (opcional)
export const getShareScopeBadgeProps = (routeOrScope) => {
  const scope = getShareScope(routeOrScope);
  const text = getShareScopeLabel(scope);
  const title =
    scope === "none"
      ? "Sólo tú puedes verla"
      : scope === "institution"
        ? "Visible para docentes de tu centro"
        : "Visible para toda la comunidad";

  const className =
    scope === "none"
      ? "badge-share badge-private"
      : scope === "institution"
        ? "badge-share badge-institution"
        : "badge-share badge-global";

  return { text, title, className, scope };
};
